// ABOUTME: Provider for the parts of CAccordion; the context and hook live in useAccordionContext.ts

import type { ReactNode } from "react"
import { AccordionContext, type AccordionContextValue } from "./useAccordionContext"

interface ICounterProvider {
  children: ReactNode
  value: AccordionContextValue
}

function AccordionProvider({ children, value }: ICounterProvider) {
  return <AccordionContext.Provider value={value}>{children}</AccordionContext.Provider>
}

export { AccordionProvider }
